/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-27 22:11:43 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 14:06:51
 */

<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Seller FAQ"/>
    <div class="docs">
      <h1>Manage Deals in Bulk</h1>
      <h2>1. How do I manage deals in bulk?</h2>
      <ul>
        <li>Go to the Products Management page and click “Manage Deals.”</li>
        <li>
          Download the CSV template, update your deal information, and upload it
          back to Artemis Ads.
        </li>
      </ul>
      <p>
        Tips: Make sure you use the right amazon seller account information,
        keep the data/time format consistent as the original template.
      </p>
      <p>That’s it! Publishers will see your products are on sale.</p>
      <h2>2. Will managing deals on Artemis Ads affect my Amazon listings?</h2>
      <p>No.</p>
      <p>
        Managing deals on Artemis Ads does not change anything on Amazon. It
        only helps to share the deal information with the potential
        publishers/creators.
      </p>
      <p>
        Please make sure to create promotion codes, coupons and deals
        accordingly at Amazon.com.
      </p>
      <h2>3. What if I need help?</h2>
      <p>
        Contact us at Support@ArtemisAds.com for assistance with bulk deal
        management.
      </p>
      <p>Quick Tip</p>
      <ul>
        <li>Use the CSV template to update deals quickly and efficiently.</li>
        <li>
          Make sure you use the right amazon seller account information, keep
          the data/time format consistent as the original template.
        </li>
      </ul>
      <img
        src="seller/manage-deals-in-bulk.png"
        alt="ArtemisAds help center"
      />
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>